import React from "react";
import "./UserStatusBadge.scss";

const getStatusConfig = (
  status: string
): { label: string; className: string } => {
  const normalized = (status ?? "").trim().toLowerCase();

  if (normalized === "enable" || normalized === "enabled") {
    return { label: "Enabled", className: "enabled" };
  }
  if (normalized === "invited") {
    return { label: "Invited", className: "invited" };
  }
  if (normalized === "disable" || normalized === "disabled") {
    return { label: "Disabled", className: "disabled" };
  }

  return {
    label: status,
    className: "disabled",
  };
};

const UserStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const { label, className } = getStatusConfig(status);

  return (
    <span className={`um-status-chip um-status-chip--${className}`}>
      {label}
    </span>
  );
};

export default UserStatusBadge;
